import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Image, Loader2, Upload, Trash2 } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

import { API } from '@/lib/apiBase';

export const LogoSiteNameCard = ({
  settings, updateField,
  logoRef, uploadingLogo, removingLogo,
  onLogoUpload, onLogoRemove,
  imgVersion,
}) => {
  const { t } = useLanguage();

  return (
    <Card className="bg-card border-border">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-6">
          <Image className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-bold">{t('siteSettings.logo')} & {t('siteSettings.siteName')}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <Label className="text-sm">{t('siteSettings.siteName')}</Label>
            <Input
              value={settings.site_name || ''}
              onChange={(e) => updateField('site_name', e.target.value)}
              placeholder="SchoolPix"
              className="bg-secondary border-border mt-1"
              data-testid="site-name-input"
            />
            <p className="text-xs text-muted-foreground mt-1">{t('siteSettings.siteNameHint')}</p>
          </div>
          <div>
            <Label className="text-sm">{t('siteSettings.logo')}</Label>
            <div className="flex items-center gap-4 mt-1">
              {settings.has_custom_logo && (
                <img
                  src={`${API}/site-settings/logo?${imgVersion}`}
                  alt="Logo"
                  className="w-12 h-12 object-contain rounded-sm bg-muted"
                />
              )}
              <div>
                <input ref={logoRef} type="file" accept="image/*" onChange={onLogoUpload} className="hidden" />
                <div className="flex items-center gap-2">
                  <Button
                    variant="outline" size="sm"
                    onClick={() => logoRef.current?.click()}
                    disabled={uploadingLogo}
                    data-testid="upload-logo-btn"
                  >
                    {uploadingLogo ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />}
                    {t('siteSettings.uploadLogo')}
                  </Button>
                  {settings.has_custom_logo && (
                    <Button
                      variant="outline" size="sm"
                      onClick={onLogoRemove}
                      disabled={removingLogo}
                      className="text-destructive hover:text-destructive border-destructive/30 hover:border-destructive/50 hover:bg-destructive/10"
                      data-testid="remove-logo-btn"
                    >
                      {removingLogo ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Trash2 className="w-4 h-4 mr-2" />}
                      {t('siteSettings.removeLogo')}
                    </Button>
                  )}
                </div>
                <p className="text-xs text-muted-foreground mt-1">{t('siteSettings.logoHint')}</p>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
